import { useDispatch } from '@redux';
import { changePassword } from '@redux/auth/actions';
import { Button, Form, Input } from 'antd';
import PublicHeader from 'layout/PublicLayout/PublicHeader';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function NewPassword({ data }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleConfirm = (values) => {
    navigate('/login');
    setLoading(true);
    dispatch(changePassword({ ...data, newPassword: values.newPassword })).then(
      ({ payload }) => {
        setLoading(false);
        if (payload?.success) {
          navigate('/login');
        }
      },
    );
  };

  const handleValidator = ({ getFieldValue }) => ({
    validator(_, value) {
      if (!value || getFieldValue('newPassword') === value) {
        return Promise.resolve();
      }
      return Promise.reject(
        new Error(t('input.repeatNewPassword.validateMsg.notMatch')),
      );
    },
  });

  return (
    <div>
      <PublicHeader
        title="common.auth.enterNewPassword"
        subtitle="common.auth.enterNewPasswordSub"
      />
      <Form onFinish={handleConfirm} layout="vertical">
        <Form.Item
          name="newPassword"
          rules={[
            {
              required: true,
              message: t('input.newPassword.validateMsg.required'),
            },
          ]}
        >
          <Input.Password placeholder={t('input.newPassword.placeholder')} />
        </Form.Item>
        <Form.Item name="repeatNewPassword" rules={[handleValidator]}>
          <Input.Password
            placeholder={t('input.repeatNewPassword.placeholder')}
          />
        </Form.Item>

        <Button
          htmlType="submit"
          type="primary"
          className="mt-[10px] w-full"
          loading={loading}
        >
          {t('button.confirm')}
        </Button>
      </Form>
    </div>
  );
}
